import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { Button } from '@mui/material';
import React from 'react';
import { IOsiServiceSaldoWidgetViewModel } from '@shared/types/mobx/widgets/OsiServiceSaldo';
import { observer } from 'mobx-react-lite';
import { useTranslation } from '@shared/utils/i18n';
import { useCanAttach } from '@shared/hooks/useCanAttach';

interface Props {
  groupId: number;
  vm: IOsiServiceSaldoWidgetViewModel;
}

// Кнопка «Прикрепить» — грузит Excel начального сальдо для конкретной группы услуг.
// Образец: widgets/osi/abonents/ui/ImportAbonentsButton.tsx.
export const AttachSaldoButton: React.FC<Props> = observer(({ groupId, vm }) => {
  const { t } = useTranslation();
  // OSI-808 п.7: кнопка «Прикрепить» (импорт начального сальдо из Excel) во вкладке
  // «Начальное сальдо» раздела «Начисление платежей» скрыта для всех ролей,
  // кроме OPERATOR / ADMIN / MAIN_OPERATOR.
  // Скрываем именно рендером (return null), а не disabled — по требованию задачи.
  // Компонент уже observer, поэтому чтение observable-ролей внутри useCanAttach реактивно.
  const canAttach = useCanAttach();

  if (!canAttach) return null;

  // ВАЖНО: id input уникален на каждую группу (saldo-file-${groupId}),
  // иначе htmlFor у label сработал бы на первый input с этим id (не на нужную группу).
  const inputId = `saldo-file-${groupId}`;

  return (
    <>
      <input
        accept=".xlsx"
        style={{ display: 'none' }}
        id={inputId}
        type="file"
        onChange={async (e) => {
          if (!e.target.value || !e.target.files?.length) return;

          await vm.importSaldo(groupId, e.target.files[0]);
          // @ts-expect-error нужно для обнуления, ts не поддерживает синтаксис
          e.target.value = null;
        }}
      />
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label htmlFor={inputId}>
        <Button variant="outlined" color="primary" component={'span'} startIcon={<CloudDownloadIcon />}>
          {t('common:attach')}
        </Button>
      </label>
    </>
  );
});
